<script setup lang="ts">
/**
 * POSTリクエストでの、APIローディング表示コンテンツ。
 */
import { ApiPostLoadStatus, ApiPostLoadStatusType } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiPostLoadStatusType;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<div class="revico-api-master">
		<!-- API発火前状態に表示するコンテンツ -->
		<slot v-if="status === ApiPostLoadStatus.beforeRequest" name="beforeRequest"></slot>

		<!-- APIローディング状態に表示するコンテンツ -->
		<template v-if="status === ApiPostLoadStatus.loading">
			<api-loading-display />
			<slot name="loading"></slot>
		</template>

		<!-- API成功時に表示するコンテンツ -->
		<slot v-else-if="status === ApiPostLoadStatus.success" name="afterApiSuccess"></slot>

		<!-- API失敗時に表示するコンテンツ -->
		<api-error-display v-else-if="status === ApiPostLoadStatus.error" />
	</div>
</template>
